import * as React from 'react';

import BaseLocationListLayout from './BaseLocationListLayout';
import LocationEditPopup from '../containers/locations/LocationEditPopup';

export default function ({ locationId }) {
  return BaseLocationListLayout(
    <LocationEditPopup locationId={locationId} />
  );
};
